import { createFileRoute } from '@tanstack/react-router';
import { SchemaPage } from '@/features/foodcost/SchemaPage';

export const Route = createFileRoute('/_app/foodcost/schema')({ component: SchemaPage });
